import { render, staticRenderFns } from "./Skills.vue?vue&type=template&id=d28edfb6&"
import script from "./Skills.vue?vue&type=script&lang=ts&"
export * from "./Skills.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports